(function ($, Drupal) {
  Drupal.behaviors.slickInit = {
    attach: function (context, settings) {
      $(once('slick-slider', '.slick-slider', context)).slick({
        slide: '.field-slide-reference',
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        prevArrow: '<i class="d-md-block fas fa-circle-chevron-left slick-prev" aria-hidden="true"></i>',
        nextArrow: '<i class="d-md-block fas fa-circle-chevron-right slick-next" aria-hidden="true"></i>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              adaptiveHeight: true
            }
          }
        ]
      });
    }
  }

  Drupal.behaviors.slickInitBenefits = {
    attach: function (context, settings) {
      $(once('benefts-slider', '.benefits.slider', context)).slick({
        slide: '.benefits.slider .slide',
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        lazyLoad: 'ondemand',
        prevArrow: '<i class="d-md-block fas fa-circle-chevron-left slick-prev" aria-hidden="true"></i>',
        nextArrow: '<i class="d-md-block fas fa-circle-chevron-right slick-next" aria-hidden="true"></i>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              adaptiveHeight: true
            }
          }
        ]
      });
    }
  }
})(jQuery, Drupal);
